import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
const subs = new Set();

export const loadAppSettings = async () => {
  const { data } = await api.get("/settings/public");
  cache = data;
  subs.forEach((fn) => fn(data));
  return data;
};

export const setAppSettingsCache = (data) => {
  cache = data;
  subs.forEach((fn) => fn(data));
};

export const useAppSettings = () => {
  const [s, setS] = useState(cache);
  useEffect(() => {
    subs.add(setS);
    if (!cache) { loadAppSettings().catch(() => {}); }
    return () => { subs.delete(setS); };
  }, []);
  return s || {};
};
